import { FilterCommonEventType } from '../enums';

const MinMaxEvents = {
  methods: {
    handleMinMaxChange(values) {
      this.$emit(FilterCommonEventType.Change, values);
    },
  },
};

export default MinMaxEvents;
